<div fxLayout="column" class="navigation-container" [style.width.px]="width">
  <abc-button
    *ngFor="let navigationEntry of navigationEntries"
    [ngClass]="{ active: navigationEntry.isSelected }"
    class="control-button"
    (click)="loadComponent(navigationEntry)"
    [id]="navigationEntry.componentName"
    [stylingMode]="'text'"
    type="normal"
    [toolTipContent]="navigationEntry.toolTip"
    [icon]="navigationEntry.icon"
  >
  </abc-button>
</div>
